import { useEffect, useState } from "react";
import { searchSiteContent } from "@/lib/strapi";

const createEmptyResults = () => ({
  sports: [],
  travel: [],
  interviews: [],
  clubs: [],
  meets: [],
});

export function useGlobalSearch(query, { enabled = true, limit = 5, debounceMs = 250 } = {}) {
  const [results, setResults] = useState(createEmptyResults());
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [hasSearched, setHasSearched] = useState(false);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const trimmedQuery = String(query || "").trim();

    if (trimmedQuery.length < 2) {
      setResults(createEmptyResults());
      setIsLoading(false);
      setError("");
      setHasSearched(false);
      return;
    }

    let mounted = true;

    setIsLoading(true);
    setError("");

    const timer = window.setTimeout(async () => {
      try {
        const nextResults = await searchSiteContent(trimmedQuery, { limit });
        if (mounted) {
          setResults(nextResults);
          setHasSearched(true);
        }
      } catch (err) {
        if (mounted) {
          setError(err instanceof Error ? err.message : "Failed to search site");
          setResults(createEmptyResults());
        }
      } finally {
        if (mounted) {
          setIsLoading(false);
        }
      }
    }, debounceMs);

    return () => {
      mounted = false;
      window.clearTimeout(timer);
    };
  }, [query, enabled, limit, debounceMs]);

  return {
    results,
    isLoading,
    error,
    hasSearched,
  };
}